<template>
  <div>
    <obk-description-id-note-step step-number="1" />
    <obk-description-no-incognito-step step-number="2" />
    <obk-description-canceled-cards-note-step step-number="3" />
  </div>
</template>

<script>
import ObkDescriptionNoIncognitoStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionNoIncognitoStep.vue';
import ObkDescriptionIdNoteStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionIdNoteStep.vue';
import ObkDescriptionCanceledCardsNoteStep
  from '@/base-components/onboarding/openBanking/obk-redirect-descriptions/ObkDescriptionCanceledCardsNoteStep.vue';

export default {
  name: 'OpenBankingIsracardDescription',
  components: { ObkDescriptionCanceledCardsNoteStep, ObkDescriptionIdNoteStep, ObkDescriptionNoIncognitoStep },
};
</script>

<style scoped lang="scss">
</style>
